import React from 'react';
import { Popup } from 'framework7-react';
import './SignatureHorizontalPopup.css';
import Signature from '../../signature/Signature';
import FormTemplate from '../../templates/formTemplates/FormTemplate';
import Content from '../../helpers/content/Content';
import Label from '../../label/Label';
import PrimaryButton from '../../primaryButton/PrimaryButton';

export default class SignatureHorizontalPopup extends FormTemplate {
	constructor(props) {
		super(props);
		this.myRefs = {};
	}

	close = () => {
		window.popupController.hide(SignatureHorizontalPopup);
	};

	finish = () => {
		const img = this.myRefs.guest_verify__signature_img.getValue();
		this.rotateImage(img, -90).then((rotatedImg) => {
			this.props.onFinish(rotatedImg);
		});
	};

	rotateImage = (imageDataUrl, degrees) => {
		return new Promise((resolve) => {
			const img = new Image();
			img.onload = () => {
				// Create a temporary canvas
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');

				// For 90 degree rotation, swap width and height
				canvas.width = img.height;
				canvas.height = img.width;

				// Translate and rotate
				ctx.translate(canvas.width / 2, canvas.height / 2);
				ctx.rotate((degrees * Math.PI) / 180);
				ctx.translate(-img.width / 2, -img.height / 2);

				// Draw the rotated image
				ctx.drawImage(img, 0, 0);

				// Get the rotated image as data URL
				const rotatedDataUrl = canvas.toDataURL();
				resolve(rotatedDataUrl);
			};
			img.src = imageDataUrl;
		});
	};

	render() {
		return (
			<Popup className={'g-signature-horizontal-popup'} opened={this.props.opened} tabletFullscreen={true}>
				<Content>
					<Label dark large center>
						Signature
					</Label>
					<Signature required ref={(ref) => (this.myRefs.guest_verify__signature_img = ref)} />
					<PrimaryButton onClick={this.finish}>Done</PrimaryButton>
				</Content>
			</Popup>
		);
	}
}

